



































import { Component, Vue, Prop, Provide, Watch, Emit } from 'vue-property-decorator'
import { Modal } from '@/components'
import { sa } from '@/utils/sa'
import { couponNum, syncPaper, updateQuestionCart, getDownloadInfo } from './../model/api'

@Component({
  components: { Modal }
})
export default class DownLoadMOdal extends Vue {
  @Prop() public value!: boolean
  @Prop() public home!: string
  public visible = false
  public name = ''
  public value1 = '1'
  public value3 = '1'
  public data: any = {}
  public title = '试卷下载'
  public loading = false

  public plainOptions1 = [
    { label: 'DOCX-标准版', value: '1' },
    { label: 'DOCX-紧凑版', value: '2' }
  ]
  public plainOptions3 = [
    { label: '普通试卷（答案在卷尾）', value: '1' },
    { label: '教师试卷（答案在题目后）', value: '2' }
  ]
  public get cartInfo() {
    return this.$store.state.question.cart
  }
  public get subjectId() {
    return this.$store.state.subject.value
  }
  @Watch('value')
  public onValueChange(val: boolean) {
    this.visible = val
  }
  @Emit()
  onCancel(val: any) {
    return val
  }
  @Emit()
  onFinish(val: { finish: boolean; url: string }) {
    return val
  }
  public closeModal() {
    this.visible = false
    this.onCancel(this.visible)
  }
  public async clearCart() {
    let params = {
      question_cart: {
        question_ids: []
      },
      subject_id: this.subjectId
    }
    let { msg } = await updateQuestionCart(params)
  }
  public async download() {
    // setTimeout(() => {
    //   sa.track('ContentRepository_question_Download', {
    //     action: '点击下载',
    //     mode: this.value3 === '1' ? '普通试卷' : '教师试卷',
    //     modules: this.$route.path === '/auto/preview' ? '智能出题' : '手工组卷'
    //   })
    // }, 50)
    this.loading = true
    let data = await syncPaper({
      subject_id: this.subjectId,
      mode: this.value3,
      format: 'docx',
      render_mode: this.value1
    })
    this.loading = false
    if (data.success) {
      this.visible = false
      // sa.track('ContentRepository_question_Download', {
      //   action: '下载成功',
      //   mode: this.value3 === '1' ? '普通试卷' : '教师试卷',
      //   modules: this.$route.path === '/auto/preview' ? '智能出题' : '手工组卷'
      // })
      // this.clearCart()
      this.onFinish({ finish: true, url: data.msg.paper_url })
      this.$message.success('试卷已同步到题库')
      if (data.msg && data.msg.paper_url) {
        window.open(data.msg.paper_url)
      }
    } else {
      this.$message.warning(data.error)
      this.onFinish({ finish: false, url: '' })
    }
  }
  public onChange1() {}
  public onChange3() {}
}
